(function () {
  var vids = document.querySelectorAll('video.clip-video[data-src]');
  if (!vids.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function attach(v) {
    if (v.src) return false;
    v.muted = true;
    v.setAttribute('muted', '');
    v.preload = 'auto';
    v.src = v.getAttribute('data-src');
    v.load();
    return true;
  }

  function tryPlay(v) {
    var p = v.play();
    if (p && p.catch) {
      p.catch(function (err) {
        if (err && err.name === 'NotAllowedError') v.setAttribute('controls', '');
      });
    }
  }

  if (reduce || saveData) {
    Array.prototype.forEach.call(vids, function (v) {
      v.setAttribute('controls', '');
      v.addEventListener('play', function () { attach(v); }, { once: true });
    });
    return;
  }

  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(vids, function (v) {
      attach(v);
      v.addEventListener('canplay', function () { tryPlay(v); }, { once: true });
    });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (attach(v)) {
          if (v.readyState >= 3) tryPlay(v);
          else v.addEventListener('canplay', function () { tryPlay(v); }, { once: true });
        } else {
          tryPlay(v);
        }
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '150px 0px', threshold: 0.25 });

  Array.prototype.forEach.call(vids, function (v) { io.observe(v); });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      Array.prototype.forEach.call(vids, function (v) { if (!v.paused) v.pause(); });
    }
  });
})();